import { useQuery } from "@tanstack/react-query";

import { BannerDataFromApi } from "components/Navbar/Controls/Settings/BannerManagement/types";
import {
    BANNER_LEVEL_LABELS,
    BannerData,
    ENDPOINT_PATH_SEGMENTS,
    ENDPOINTS,
    QUERY_KEYS,
    useApi
} from "shared";

const useMaintenanceBanner = () => {
    const getActiveBannerStatus = async () => {
        try {
            const { data } = await getData(
                `${ENDPOINTS.Banners}${ENDPOINT_PATH_SEGMENTS.Active}`
            );

            const allActiveBanners: BannerDataFromApi[] = data;

            if (allActiveBanners.length > 0) {
                const activeBanner = allActiveBanners[0];
                const { id, is_active, level, message } = activeBanner;

                return {
                    id,
                    level: level as BANNER_LEVEL_LABELS,
                    message: message,
                    isActive: is_active
                };
            }

            return null;
        } catch (error) {
            handleResponse(error);
            throw error;
        }
    };

    const { getData, handleResponse } = useApi();

    return useQuery<BannerData | null>({
        queryKey: QUERY_KEYS.banners.active,
        queryFn: getActiveBannerStatus,
        retry: false
    });
};

export { useMaintenanceBanner };
